module.exports = __webpack_public_path__ + "_assets/img/mission-c.96363421.svg";